var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('question',{attrs:{"text":_vm.$t(_vm.item.text)}}),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"12","sm":"10","md":"8"}},[_c('select-input',{staticClass:"w-100",attrs:{"options":_vm.selectOptions,"max":_vm.max,"min":_vm.min},on:{"select":_vm.handleSelect}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }